import React from 'react';
import { Input, Button, Select } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

interface QueryParamsProps {
  deptFrom: string;
  deptTo: string;
  year: number;
  month: string;
  deptLevel: number;
  company: number;
  loading: boolean;
  onDeptFromChange: (v: string) => void;
  onDeptToChange: (v: string) => void;
  onYearChange: (v: number) => void;
  onMonthChange: (v: string) => void;
  onDeptLevelChange: (v: number) => void;
  onCompanyChange: (v: number) => void;
  onQuery: () => void;
}

const monthOptions = Array.from({ length: 12 }, (_, i) => ({
  value: String(i + 1).padStart(2, '0'),
  label: String(i + 1).padStart(2, '0'),
}));

const deptLevelOptions = [
  { value: 1, label: '1-部' },
  { value: 2, label: '2-處' },
  { value: 3, label: '3-課' },
  { value: 4, label: '4-組' },
];

const companyOptions = [
  { value: 1, label: '1-台北渤揚' },
  { value: 2, label: '2-昆山渤揚' },
  { value: 3, label: '3-全部' },
];

const QueryParams: React.FC<QueryParamsProps> = ({
  deptFrom, deptTo, year, month, deptLevel, company, loading,
  onDeptFromChange, onDeptToChange, onYearChange, onMonthChange,
  onDeptLevelChange, onCompanyChange, onQuery,
}) => {
  return (
    <div className="bg-gray-50 border border-gray-200 rounded p-4 mb-4">
      {/* Row 1: Department range */}
      <div className="flex flex-wrap items-center gap-4 mb-3">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium" style={{ width: 96 }}>部門代號[從]</span>
          <Input
            value={deptFrom}
            onChange={(e) => onDeptFromChange(e.target.value.toUpperCase())}
            placeholder="起"
            style={{ width: 80 }}
            maxLength={4}
          />
          <span className="text-sm">[至]</span>
          <Input
            value={deptTo}
            onChange={(e) => onDeptToChange(e.target.value.toUpperCase())}
            placeholder="迄"
            style={{ width: 80 }}
            maxLength={4}
          />
        </div>
      </div>

      {/* Row 2: Year-month */}
      <div className="flex flex-wrap items-center gap-4 mb-3">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium" style={{ width: 96 }}>年度月份:</span>
          <Input
            type="number"
            value={year}
            onChange={(e) => onYearChange(parseInt(e.target.value, 10) || 0)}
            style={{ width: 85 }}
            min={1990}
            max={2099}
          />
          <span className="text-sm">年</span>
          <Select
            value={month}
            onChange={onMonthChange}
            options={monthOptions}
            style={{ width: 85 }}
          />
          <span className="text-sm">月</span>
        </div>
      </div>

      {/* Row 3: Dept level + Company */}
      <div className="flex flex-wrap items-center gap-4 mb-3">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium" style={{ width: 96 }}>部門分級:</span>
          <Select
            value={deptLevel}
            onChange={onDeptLevelChange}
            options={deptLevelOptions}
            style={{ width: 100 }}
          />
        </div>
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium">公司分級:</span>
          <Select
            value={company}
            onChange={onCompanyChange}
            options={companyOptions}
            style={{ width: 140 }}
          />
        </div>
      </div>

      {/* Query button */}
      <div className="flex gap-2">
        <Button type="primary" icon={<SearchOutlined />} onClick={onQuery} loading={loading}>
          查詢
        </Button>
      </div>
    </div>
  );
};

export default QueryParams;
